export * from './copy-video-modal-container.component';